import { makeStyles } from '@material-ui/core/styles';
import {
  Create,
  FileField,
  FileInput,
  SimpleForm,
  TextInput,
} from 'react-admin';

const useStyles = makeStyles({
  input: {
    width: '20%',
    borderRadius: '4px',
  },
  bottomText: {
    width: '20%',
  },
});
const VuceDispatchCreate = (props) => {
  const classes = useStyles();
  return (
    <Create {...props} redirect={false} basePath="" resource="">
      <SimpleForm>
        <FileInput
          id="file"
          source="files"
          placeholder={<p>Drop your file here</p>}
        >
          <FileField />
        </FileInput>
        <TextInput
          className={classes.bottomText}
          source="change"
          label="Cambio USD"
        />

        <TextInput
          className={classes.bottomText}
          source="operationNumber"
          label="Nmr operacion"
        />
        <TextInput
          className={classes.bottomText}
          source="paymentId"
          label="Id pago"
        />
      </SimpleForm>
    </Create>
  );
};
export default VuceDispatchCreate;
